export enum GridMovementDirection {
  Up,
  Down,
  Left,
  Right,
}
